
import { PropertiesList } from "components/UI/PropertiesList/PropertiesList.tsx";
import { ShortenedTextWithCopy } from "components/UI/ShortenedTextWithCopy";
import { FC } from "react";

import FormSubmissionValueData = App.Data.FormSubmissionValueData;

interface LogDataSectionProps {
    formSubmissionValues?: FormSubmissionValueData[];
    noDataMessage: string;
}

export const LogDataSection: FC<LogDataSectionProps> = ({ formSubmissionValues, noDataMessage }) => {
    if (!formSubmissionValues || formSubmissionValues.length === 0) {
        return <div>{noDataMessage}</div>;
    }

    return (
        <PropertiesList
            list={PropertiesList.create(
                formSubmissionValues,
                formSubmissionValues.map((formSubmissionValue: FormSubmissionValueData) => ({
                    term: formSubmissionValue.name,
                    description: () =>
                        formSubmissionValue.value !== null && formSubmissionValue.value !== undefined
                            ? formSubmissionValue.value
                            : "-",
                    render: () => {
                        if (formSubmissionValue.value === null || formSubmissionValue.value === undefined) {
                            return "-";
                        }

                        return <ShortenedTextWithCopy text={String(formSubmissionValue.value)} />;
                    },
                }))
            )}
        />
    );
};
